import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.van-base-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--van-base-slider' )[0], {
          type: 'fade',
          pagination: false,
          arrows: true,
          gap: '0px',
          autoWidth: false,
          perPage: 1,
          rewind: true,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'van-base-slider', COMPONENT );
} )( app );
